import { useEffect, useRef } from "react";
import "./styles/loader.css";

export default function Loader() {
  const logoRef = useRef(null);

useEffect(() => {
  const img = logoRef.current;

  console.log({
    src: img.src,
    complete: img.complete,
    naturalWidth: img.naturalWidth,
    naturalHeight: img.naturalHeight,
    clientWidth: img.clientWidth,
    clientHeight: img.clientHeight,
    offsetWidth: img.offsetWidth,
    offsetHeight: img.offsetHeight,
  });

  console.log(img);
}, []);

  return (
    <div className="loader-screen">
      <div className="loader-content">
        <img
          ref={logoRef}
          src="/portfolio-loader-logo.png"
          alt="Liege"
          className="loader-logo-img"
        />

        <h1 className="loader-logo">Portfolio</h1>
        <p className="loader-subtitle">Joel R. George</p>

        <div className="loader-bar">
          <div className="loader-progress"></div>
        </div>
      </div>
    </div>
  );
}